export default __webpack_public_path__ + "996950f692478cfd4c4affd391cff2ed.png";